import { render, staticRenderFns } from "./active_taisam_robot.vue?vue&type=template&id=6ba303ed&"
import script from "./active_taisam_robot.vue?vue&type=script&lang=ts&"
export * from "./active_taisam_robot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports